import { ReportStatus } from '@littlebird/sdk';
import { format } from 'date-fns/format';
import { isSameWeek } from 'date-fns/isSameWeek';
import { isToday } from 'date-fns/isToday';
import { isYesterday } from 'date-fns/isYesterday';

import { formatTime } from '@/utils/date';

export const parseStatus = (reportText: string) => {
  if (reportText === ReportStatus.NO_DATA) {
    return ReportStatus.NO_DATA;
  }

  if (reportText === ReportStatus.GENERATING) {
    return ReportStatus.GENERATING;
  }

  return null;
};

export const formatNoteDate = (date: string | Date) => {
  const d = typeof date === 'string' ? new Date(date) : date;
  const time = formatTime(d);

  if (isToday(d)) {
    return `Today, ${time}`;
  }

  if (isYesterday(d)) {
    return `Yesterday, ${time}`;
  }

  if (isSameWeek(d, new Date())) {
    return `${format(d, 'E, MMM d')}, ${time}`;
  }
  return `${format(d, 'MMM d')}, ${time}`;
};
